import type { ReactElement } from "react";
import { useSofortPopup } from "@kundeninfo/ui";
import { Chip } from "@kundeninfo/ui/me-design";
import { HISTORICAL_TEXT as T } from "./texts.js";

/**
 * Das Kennzeichen „historisch“ (Spec „Historische Vorgänge anlegen und anzeigen“): ein rahmenloser Chip — Fläche heißt
 * Kennzeichen, nicht anklickbar (Hausregel 27.10.2026) — mit Sofort-Popup statt `title`. EIN Baustein für Detail,
 * Bereichszeile und die Vorgangs-Chips am Kundenreiter „Dateien“.
 */
export function HistoricalChip(): ReactElement {
  const popup = useSofortPopup<HTMLElement>(T.popup);
  return <Chip ref={popup}>{T.chip}</Chip>;
}
